define(['core/jed!core/nls/load'], function(i18n) {
return {
	loading: i18n.gettext("Loading...")
}
});
